import FilterItem from "./FilterItem";
import { SnapshotIn } from "mobx-state-tree";

const City = FilterItem.named("City");

export default City;
export interface ICitySnapshotIn extends SnapshotIn<typeof City> {}
